import userService from '../../services/user.service';
import {
  ADMISSION_CHECKLIST_LOCATION,
  ADMISSION_UPDATE_CATEGORY,
  ADMISSION_UPDATE_CATEGORY_LOCATION,
  ADMISSION_USE_CACHE,
  APPLICATION_REFRESH_DATE,
  APP_IS_READY,
  AUTH_LOGIN,
  AUTH_UPDATE_TOKEN,
  INITIAL_STATE,
  OWNERS_TRANSFER_OWNERSHIP,
} from '../actions';
import { getAdmissionData } from '../actions/admission.actions';

export const admissionCacheMiddleware =
  ({ dispatch, getState }) =>
  next =>
  action => {
    next(action);

    if (action.type === INITIAL_STATE) {
      const { admission } = getState();
      const hasCachedData = admission.categories?.length > 0;

      if (hasCachedData) {
        dispatch({ type: ADMISSION_USE_CACHE });
      }
    }
  };

export const admissionFetchDataMiddleware =
  ({ dispatch }) =>
  next =>
  async action => {
    next(action);

    if (
      action.type === AUTH_LOGIN ||
      action.type === APP_IS_READY ||
      action.type === AUTH_UPDATE_TOKEN ||
      action.type === APPLICATION_REFRESH_DATE ||
      action.type === OWNERS_TRANSFER_OWNERSHIP ||
      action.type === ADMISSION_UPDATE_CATEGORY_LOCATION ||
      action.type === ADMISSION_CHECKLIST_LOCATION
    ) {
      if (!userService.isAuthenticated) return false;

      console.log('fetch admission');
      dispatch(getAdmissionData());
    }
  };

export const admissionOnCategoryChangeOwnerIdMiddleware =
  ({ dispatch }) =>
  next =>
  async action => {
    next(action);

    if (action.type === ADMISSION_UPDATE_CATEGORY) {
      if (!action.payload.ownerIds) return false;

      dispatch(getAdmissionData());
    }
  };

export const admissionMiddleware = [
  admissionCacheMiddleware,
  admissionFetchDataMiddleware,
  admissionOnCategoryChangeOwnerIdMiddleware,
];
